import React from 'react';
import type { GrundlagenProps } from './typen';

/** Abschnitt „Baubeschreibung" samt ergaenzenden Angaben zur Bauaufgabe. */
export const GrundlagenBeschreibung: React.FC<GrundlagenProps> = ({
    baubeschreibung, bauaufgabe, isReadOnly, onChange,
}) => (
    <section className="bg-white rounded-2xl border border-slate-200 p-5">
        <h3 className="font-bold text-slate-800 mb-1">Baubeschreibung</h3>
        <p className="text-xs text-slate-500 mb-3">
            Das Bauvorhaben in eigenen Worten: Neubau oder Bestand, Abbruch, Baugrube, Bauweise, Kran,
            Gerüst, Dach, Umfeld. Je genauer, desto mehr Fragen kann „Baubeschreibung auswerten (KI)“
            darunter ausschließen. Wird auf Wunsch der Klärungsliste vorangestellt.
        </p>
        <textarea
            value={baubeschreibung}
            disabled={isReadOnly}
            onChange={e => onChange('baubeschreibung', e.target.value)}
            rows={7}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm leading-relaxed disabled:bg-slate-50"
            placeholder="Art und Umfang des Bauvorhabens, Bestand, Umfeld, Besonderheiten …"
        />
        <div className="mt-4">
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1">
                Ergänzende Angaben zur Bauaufgabe
            </label>
            <textarea
                value={bauaufgabe}
                disabled={isReadOnly}
                onChange={e => onChange('bauaufgabe', e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm disabled:bg-slate-50"
                placeholder="Vertragliche Besonderheiten, Auflagen, Randbedingungen …"
            />
        </div>
    </section>
);
